const Pamphlets = {
  init(target) {
    const loadMoreBtn = target.querySelector('.docs__loadmore button')
    const innerContainer = target.querySelector('.docs__innercontainer')

    loadMoreBtn.addEventListener('click', (e) => this.loadMore(e, innerContainer))
  },
  loadMore(e, innerContainer) {
    e.preventDefault()
    innerContainer.classList.remove('docs__init')
    e.target.parentElement.classList.add('docs__loadmore--hide')
  },
}

export default Pamphlets
